import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '~/components/composites/confirm-dialog'
import { useMutation } from '~/hooks/use-mutation'
import { useQueryClientHelper } from '~/hooks/use-query-client'
import { useToast } from '~/hooks/use-toast'
import { useAppStore } from '~/stores/app'
import { DialogId } from '~/types/common'
import { MutationKey } from '~/types/mutation-key'
import type { NgWord } from '~/types/ng-word'
import { QueryKey } from '~/types/query-key'

type NgWordDeleteDialogProps = {
  deletingItem?: NgWord | null
}

export function NgWordDeleteDialog({ deletingItem }: NgWordDeleteDialogProps) {
  const { t } = useTranslation()
  const { showSuccess } = useToast()
  const { invalidateQueries } = useQueryClientHelper()
  const closeDialog = useAppStore((state) => state.closeDialog)

  const { mutate: deleteNgWord, isPending } = useMutation({
    mutationKey: MutationKey.DELETE_NG_WORD,
    method: 'DELETE',
    idParams: deletingItem ? { id: deletingItem.id } : undefined,
    options: {
      onSuccess: () => {
        showSuccess(t('common.delete'))
        invalidateQueries(QueryKey.NG_WORDS)
        closeDialog(DialogId.DELETE_NG_WORD)
      },
    },
  })

  const handleConfirm = () => {
    deleteNgWord({})
  }

  return (
    <ConfirmDialog
      dialogId={DialogId.DELETE_NG_WORD}
      title={t('common.delete')}
      description={t('ngWords.deleteConfirm')}
      onConfirm={handleConfirm}
      destructive
      loading={isPending}
    />
  )
}
